import { getLocalizedValue, getLocalizedString } from '@grandvisionhq/utils';
import { EyeSide } from '../../../../__generated__/sharedTypes.js';
import { isContactLensesOrderLineItem, isSolutionOrderLineItem } from './order-line-item-product-type-guards.js';

const getProductSubtitle = (orderLineItem, intl)=>{
    const { locale , getLabel  } = intl;
    if (isContactLensesOrderLineItem(orderLineItem)) {
        const { eyeSide  } = orderLineItem;
        const { boxQuantity , replacementFrequency  } = orderLineItem.product;
        const eyeSideLabelKey = eyeSide === EyeSide.LEFT ? 'products.contactLenses.leftEye' : 'products.contactLenses.rightEye';
        /**
     * Some of these values can end up in an empty string, in which case
     * we want to not add a space character for that value.
     */ const spaceJoinedSections = [
            boxQuantity,
            getLocalizedValue(replacementFrequency, locale),
            getLabel('products.unit.contactLenses'), 
        ].filter(Boolean).join(' ');
        const commaJoinedSections = [
            getLabel('products.perBox'),
            getLabel(eyeSideLabelKey).toLowerCase(), 
        ].filter(Boolean).join(', ');
        return `${spaceJoinedSections} ${commaJoinedSections}`;
    }
    if (isSolutionOrderLineItem(orderLineItem)) {
        const { volume , volumeUnit  } = orderLineItem.product;
        return volume && volumeUnit ? `${volume}${volumeUnit}` : undefined;
    }
    const { brand , modelCode , name  } = orderLineItem.product;
    if (!modelCode || (brand === null || brand === void 0 ? void 0 : brand.includes(modelCode)) || getLocalizedString(name, locale).includes(modelCode)) {
        return '';
    }
    return modelCode;
};

export { getProductSubtitle };
//# sourceMappingURL=get-product-subtitle.js.map
